<template>
    <div class="checkbox-com">
        <div class="head-con">
            <el-checkbox-group v-model="checkListHeadAll" @change="handleChangeHeadAll">
                <el-checkbox :label="1" >
                    <span class="c-all">全选</span>
                </el-checkbox>
            </el-checkbox-group>
            <el-checkbox-group v-model="checkListHeadNotAll" @change="handleChangeHeadNotAll">
                <el-checkbox :label="1" >
                    <span class="not-c-all">反选</span>
                </el-checkbox>
            </el-checkbox-group>
        </div>
        <el-checkbox-group v-model="checkList">
            <el-checkbox v-for="item in options" :label="item[value]" :key="item[value]" disabled:disabled>{{
                item[label] }}</el-checkbox>
        </el-checkbox-group>
    </div>
</template>

<script>
export default {
    name: 'CheckboxCom',
    props: {
        // controller: {
        //     type: String
        // },
        // method: {
        //     type: String
        // }
        disabled: {
            type: Boolean,
            default: false
        },
        value: {
            type: String,
            default: 'id',
        },
        label: {
            type: String,
        },
        options: {
            type: Array
        }
    },
    data() {
        return {
            checkListHeadAll: [],
            checkListHeadNotAll: [],
            checkList: []
        }
    },
    methods: {
        handleChangeHeadAll() {
            this.checkListHeadNotAll = []
            this.optionsChoosedAll()
        },
        handleChangeHeadNotAll() {
            this.checkListHeadAll = []
            this.optionsChoosedAllCancel()
        },
        optionsChoosedAll() {
            this.options.map(item => {
                if (this.checkList.indexOf(item[this.value]) === -1) {
                    this.checkList.push(item[this.value])
                }
            })
        },
        optionsChoosedAllCancel() {
            this.options.map(item => {
                if (this.checkList.indexOf(item[this.value]) !== -1) {
                    let index = this.checkList.indexOf(item[this.value])
                    this.checkList.splice(index,1)
                } else {
                    this.checkList.push(item[this.value])
                }
            })
        },
    }
}
</script>

<style scoped>
.checkbox-com>>>.wrapper .el-checkbox {
    text-align: left;
}

.checkbox-com .head-con {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    margin-bottom: 0.2rem;
}

.checkbox-com .c-all {
    color: #409EFF;
}

.checkbox-com .not-c-all {
    color: #E6A23C;
}
</style>


// WEBPACK FOOTER //
// src/commonReform/CheckboxCom.vue